/* eslint-disable */
import React, {PropTypes} from 'react';
import Helpers from '../../../util/Helpers'
import $ from 'jquery';
import {Chart, HorizontalBar} from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
var chartInstanceId = null;
var horizontalBarAssunto = null;

class GrafBarraHierarquiaAssuntosEstrutura extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            idNatureza: 0,
            width: 700, 
            height: 700,
            paginacarregada: false,
            assuntosAnteriores: [],
            horizontalBar:null,
            chartInstance:null

        };
        
        this.getAssuntoPai = this.getAssuntoPai.bind(this);
        this.CriarGrafico = this.CriarGrafico.bind(this);
        this.reiniciarGrafico = this.reiniciarGrafico.bind(this);
        this.voltarGrafico = this.voltarGrafico.bind(this);
        this.resizeCanvasToDisplaySize = this.resizeCanvasToDisplaySize.bind(this);
        this.fitToContainer = this.fitToContainer.bind(this);
        var self = this;
    }
   
    alerta(titulo, mensagem, tipo, posicao){
        
        // this.props.actionsAlerta.apresentarAlerta({
        //     title: titulo!==null?titulo:'Aviso!',
        //     message: mensagem!==null?mensagem:'',
        //     level: tipo!==null?tipo:'error',
        //     position: posicao!==null?posicao:'tc',
        //     showMsg: true,
        //     autoDismiss:25
        // });
    }

    reiniciarGrafico(){
       
        this.setState({assuntosAnteriores:[]});
        this.props.assuntoSelecionado(null)
        $( "#homeIcon" ).removeClass( "info-visivel" ).addClass( "info-invisivel" );

    }

    voltarGrafico(){
       
        if(this.state.assuntosAnteriores.length>1){
           
            var ultimoAssunto = this.state.assuntosAnteriores[this.state.assuntosAnteriores.length-2];
            var assuntos = this.state.assuntosAnteriores;
            assuntos.splice(this.state.assuntosAnteriores.length-2,2);
            this.setState({assuntosAnteriores:assuntos});           
            this.props.assuntoSelecionado(ultimoAssunto);
        }
        else{
            this.reiniciarGrafico();
        }
    }


    CriarGrafico(dataBar, width, height, relatorio){
       
        var assuntosList = [];
        if(this.state.assuntosAnteriores.length>0){
            assuntosList = this.state.assuntosAnteriores;
        }
        if(this.props.apresentarAssunto){
            assuntosList.push(this.props.apresentarAssunto);
            this.setState({assuntosAnteriores:assuntosList});
        }
        this.setState({height:height, width:width})
       
       if(horizontalBarAssunto != null) {
            horizontalBarAssunto.destroy();
            horizontalBarAssunto = null;
        }
        if(dataBar!==null){
           //console.log('databar --', dataBar)
            //se o gráfico existir é destruido.
           
            var valorTotal = 0;
            
            for(var i = 0, len = relatorio.dado.length; i < len; i++) {
                    valorTotal += relatorio.dado[i].mTotalHierarquico; 
            }

            //Referência: 
            // - Tamanho da barra: https://stackoverflow.com/questions/28990708/chartjs-how-to-set-max-and-min-value-for-y-axis
            // - Doc: http://www.chartjs.org/docs/latest/charts/bar.html#offsetgridlines

            var optionsBar = {
                plugins: {
                    datalabels:
                     {
                        // backgroundColor: function(context) {
                        //     return context.dataset.backgroundColor;
                        // },
                        backgroundColor: '#5d95fb',
                        borderRadius: 4,
                        color: 'white',
                        font: {
                            weight: 'bold'
                        },
                        formatter: Math.round
                    }
                },                
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false
                        }
                    }],
                    xAxes: [{
                        // Change here
                        barPercentage: 0.4
                    }]
                },
                responsive: true,
                maintainAspectRatio: false,
                showLines: true,
                title: {
                    display: true,
                    text: this.props.apresentarAssunto === null ? 'Total de manifestações classificadas – ' + valorTotal : 'O assunto ' + this.props.apresentarAssunto.mDescricao + ' possui: ' + (this.props.apresentarAssunto.mTotalHierarquico - valorTotal) + '. A soma dos sub assuntos é: ' + valorTotal + '. Total: ' + this.props.apresentarAssunto.mTotalHierarquico,
                },
                legend: {
                    display: false,
                    labels: {
                        fontColor: '#000000'
                    }
                },
                layout: {
                    padding: {
                        right: 35
                    }
                },
                tooltips: {
                    enabled: true
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            //suggestedMin: 0.3,    // minimum will be 0, unless there is a lower value.
                            beginAtZero: true   // minimum value will be 0.
                        },
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                }
            };

            var ctxCanvas = document.getElementById('ctxAss').getContext("2d");

            horizontalBarAssunto = new Chart(ctxCanvas,  {
                type: 'horizontalBar',
                data: dataBar,
                options: optionsBar,
                ref: 'horizontalBarAss',
                redraw:true
            });
           
            
            this.setState({horizontalBarAssunto: horizontalBarAssunto})
           
            var chartWraper = document.getElementById("chartWrapperAss");
            chartWraper.clientHeight = height;

            //USAR ESSE
            //this.resizeCanvasToDisplaySize(ctxCanvas.canvas);
            //OU ESSE, os dois parecem que funcionaram igual
            var ctxAss = document.getElementById('ctxAss');
            this.fitToContainer(ctxAss);

            var self = this;
            ctxAss.onclick = function (evt) {
               
                if (horizontalBarAssunto.config.type!="horizontalBar"){
                    
                    // document.getElementById("lbltheClickedOne").innerText = "Only available for Bar Charts";	
                } else {
                   
                    //if(horizontalBarAssunto!==undefined && horizontalBarAssunto.config.ref==='horizontalBarAss' && horizontalBarAssunto.id === chartInstanceId){
                        var activePoints = horizontalBarAssunto.getElementAtEvent(evt);
                        var theElement = horizontalBarAssunto.config.data.datasets[activePoints[0]._datasetIndex].data[activePoints[0]._index];
                        self.getAssuntoPai(activePoints[0]._index);
                        ////console.log(activePoints);
                        ////console.log(theElement);
                        ////console.log(horizontalBar.config.data.datakeys[activePoints[0]._index]);
                        // //document.getElementById("lbltheClickedOne").innerText = horizontalBar.config.data.datakeys[activePoints[0]._index];
                        ////console.log(horizontalBar.config.type);
                    //}
                }
            }
        }
        
       


    }

    fitToContainer(canvas) {
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
    }

    resizeCanvasToDisplaySize(canvas) {
        // look up the size the canvas is being displayed
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;

        // If it's resolution does not match change it
        if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
            return true;
        }

        return false;
    }

    getAssuntoPai(obj){
        
        //if(obj.length>0){
            
            //metodo da dashboard que passará o id para a modal. 
           //console.log('clicou em q gráfico ',this.props.relatorio.dado[obj].mIdAssunto);
         if(this.props.efetuarCruzamento!=='' && this.props.efetuarCruzamento!=='0'){
             //console.log('this.props.efetuarCruzamento ', this.props.efetuarCruzamento);
             window.UIModals.showModal('#visualizarRelatorioNaturezaPorAssunto');
         }
            this.props.assuntoSelecionado(this.props.relatorio.dado[obj])
            //window.UIModals.showModal('#visualizarRelatorio');
        //}
        
    }


    componentDidMount() {
        
        var height = this.definirAlturaGrafico(this.props.relatorio.dado.length)
        this.CriarGrafico(this.props.dataBar, this.state.width,height, this.props.relatorio);
        
        // Chart.pluginService.register({
        //     afterDraw: (chartInstance) => {
        //                 //console.log('chartInstance', chartInstance);
        //                 
        //                 var ctxNew = chartInstance.chart.ctx;
        //                 ctxNew.font = "10px Verdana";
        //                 ctxNew.fillStyle = "#00000";
        //                 ctxNew.textAlign = "center";
        //                 ctxNew.textBaseline = "bottom";
        //                 
        //                 if(this.state.horizontalBar!=null){
        //                     this.state.horizontalBar.chart.config.data.datasets.forEach(function (dataset) {
        //                         
        //                         const dataArray = dataset.data;
        //                         if(dataset._meta[chartInstance.id]){
        //                             //console.log('chartInstance ', chartInstance)
        //                             dataset._meta[chartInstance.id].data.forEach(function (horizontalBar, index) {
        //                                 ctxNew.fillText(dataArray[index], horizontalBar._view.x+ 6, horizontalBar._view.y+5);
        //                             });
        //                         }
        //                     })
        //                 }
        //                 chartInstanceId = chartInstance.chart.id;
        //         }
        // });
    }
    definirAlturaGrafico(qtd){
        var height = 700;
       
        if(qtd==0){
            height = 50
        }
        else if(qtd>0 && qtd<=3){
            height = 150
        }
        else if(qtd>3 && qtd<=5){
            height = 150
        }
        else if(qtd>5 && qtd<=10){
            height = 400
        }
        else if(qtd>10 && qtd<=20){
            height = 400
        }
        else if(qtd>20 && qtd<=35){
            height = 600
        }
        else if(qtd>35 && qtd<=55){
            height = 700
        }
        else{
            height = 150
        }
        return height;
    }
    componentWillReceiveProps(nextProps) {
        
        if(!$.isEmptyObject(nextProps.relatorio)){
            if (this.props.relatorio !== nextProps.relatorio) {
                
                var height = this.definirAlturaGrafico(nextProps.relatorio.dado.length)
                this.CriarGrafico(nextProps.dataBar, 700, height, nextProps.relatorio);
            }
        }
    }

    render() {
     
     //console.log('Grafico this.props.relatorio - ', this.props.relatorio)
     var width = this.state.width;
        var height = this.state.height;
        var style = { width: this.state.width, height: this.state.height };
        var styleDiv = {height: this.state.height };
        var msg = '';
        
        if(this.state.assuntosAnteriores.length>0){
            
            $( "#homeIcon" ).removeClass( "info-invisivel" ).addClass( "info-visivel" );
        }
        
        if(this.props.dataBar===null && this.props.apresentarAssunto!==null){
            
            msg = <div className='col-centered'><br/><h4>Não existe sub assunto do assunto - <strong>{this.props.apresentarAssunto.mDescricao}</strong>.</h4></div>
        }
     return (
         <div>
            <div>
                {msg}
            </div>
                    <div className='chart-container' style={styleDiv} id='chartWrapperAss' ref='chartWrapperAss'>
                        <canvas id='ctxAss' height={height} ref='ctxAss'></canvas>
                    </div>
                    
        </div>
        
    );
  }
}

export default GrafBarraHierarquiaAssuntosEstrutura;


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/Assunto/hierarquia/GrafBarraHierarquiaAssuntosEstrutura.js
 **/